import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button6',
  standalone: true,
  imports: [],
  templateUrl: './button6.component.html',
  styleUrl: './button6.component.scss'
})
export class Button6Component {
  @Input() buttonText!: string;
}
